module.exports = __webpack_public_path__ + "media/customizations/trillium/back-9e5b578e607b949ea9111014e434c8be.jpg";